import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const API = process.env.REACT_APP_API_URL || "https://api.moulirobots.com";

//  const API = process.env.REACT_APP_API_URL || "http://127.0.0.1:1500";

const Home = () => {
  const navigate = useNavigate();

  const [status, setStatus] = useState("Checking");

  useEffect(() => {
    let interval;

    const checkBackend = async () => {
      try {
        const response = await fetch(
          `${API}/api/health?time=${new Date().getTime()}`,
          {
            method: "GET",
            cache: "no-store",
          }
        );

        if (response.ok) {
          setStatus("Online");
        } else {
          setStatus("Offline");
        }
      } catch (err) {
        setStatus("Offline");
      }
    };

    // First check
    checkBackend();

    // Check every 2 seconds
    interval = setInterval(checkBackend, 2000);

    return () => clearInterval(interval);
  }, []);

  const handleLoginClick = () => navigate("/login");
  const handleSignupClick = () => navigate("/sign-up");

  return (
    <div className="Home">
      <div className="orb orb-1"></div>
      <div className="orb orb-2"></div>

      <div className="home-top">
        <span className="home-eyebrow">AI · Powered</span>

        <h1 className="head_1_home">
          English Teacher <span>Bot</span>
        </h1>

        <h2 className="head_2_home">Welcomes You</h2>

        <div className="home-divider"></div>
      </div>

      <div className="popup">
        <div
          className={`home-status ${
            status === "Online"
              ? "online"
              : status === "Offline"
              ? "offline"
              : "checking"
          }`}
        >
          <span className="home-status-dot"></span>

          {status === "Checking"
            ? "Checking..."
            : status === "Online"
            ? "System Online"
            : "System Offline"}
        </div>

        <div className="buttons-container">
          <button
            className="styled-button home-login"
            onClick={handleLoginClick}
          >
            Login
            <div className="arrow-wrapper">
              <div className="arrow"></div>
            </div>
          </button>

          <button
            className="styled-button home-signup"
            onClick={handleSignupClick}
          >
            Sign Up
            <div className="arrow-wrapper">
              <div className="arrow"></div>
            </div>
          </button>
        </div>

        <p className="home-tagline">
          Learn smarter · Not harder
        </p>
      </div>
    </div>
  );
};

export default Home;